import React, { useRef, useEffect } from "react";
import { useDrag, useDrop } from "react-dnd";
import { useTranslation } from "react-i18next";
import CustomChip from '../../../components/common/chip/chip';
import './chips.scss';
var Chips = function (props) {
    var t = useTranslation().t;
    var data = props.data, id = props.id, index = props.index, moveCard = props.moveCard, isAllowDrag = props.isAllowDrag, classes = props.classes, onChangeMetricChip = props.onChangeMetricChip, multipleIcon = props.multipleIcon, isDimension = props.isDimension, chips = props.chips;
    useEffect(function () {
        if (isAllowDrag) {
            drag(drop(ref));
        }
        else {
            drag(drop(null));
        }
    }, [isAllowDrag]);
    var ref = useRef(null);
    var _a = useDrop({
        accept: "Card",
        hover: function (item, monitor) {
            var _a;
            if (!ref.current) {
                return;
            }
            var dragIndex = item.index;
            var hoverIndex = index;
            var dragCard = chips[dragIndex];
            var hoverCard = chips[hoverIndex];
            if (dragCard.dimensionAble != hoverCard.dimensionAble)
                return;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Determine rectangle on screen
            var hoverBoundingRect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            // get hovered image vertical middle position
            var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // get hovered image horizontal middle position
            var hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
            // determine mouse position
            var clientOffset = monitor.getClientOffset();
            // get pixels to the top
            var hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // get pixels to the left
            var hoverClientX = clientOffset.x - hoverBoundingRect.left;
            // only perform the move when the mouse has crossed half of the items height/width
            // are we dragging right or left?
            var dragRight = dragIndex === (hoverIndex - 1);
            var dragLeft = dragIndex === (hoverIndex + 1);
            if (dragRight && dragIndex < hoverIndex && hoverClientX < hoverMiddleX) {
                return;
            }
            if (dragLeft && dragIndex > hoverIndex && hoverClientX > hoverMiddleX) {
                return;
            }
            if (!dragLeft && !dragRight && dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            if (!dragLeft && !dragRight && dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            // Time to actually perform the action
            if (moveCard) {
                moveCard(dragIndex, hoverIndex);
            }
            item.index = hoverIndex;
        },
    }), drop = _a[1];
    var _b = useDrag({
        item: { type: "Card", id: id, index: index },
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging(),
        }); }
    }), isDragging = _b[0].isDragging, drag = _b[1];
    var opacity = isDragging ? 0 : 1;
    var iconChips = function () {
        if (multipleIcon) {
            return React.createElement("span", null, data.icon.length ? data.icon.map(function (icon, index) { return React.createElement("img", { key: index, src: icon }); }) : null);
        }
        else {
            return React.createElement("img", { src: data.icon });
        }
    };
    return (React.createElement("div", { ref: ref, style: { opacity: opacity }, className: "chip-wrapper " + classes },
        React.createElement(CustomChip, { icon: data.icon ? iconChips() : undefined, label: data.name + (isDimension ? '*' : ''), className: "chip-style", onClick: function () {
                if (onChangeMetricChip) {
                    onChangeMetricChip(data);
                }
            } })));
};
export default Chips;
